import React from 'react';
import './LogoCarousel.css';

const logos = [
    { src: '/Images/HKU_iDendron_Logo_black-2.png', alt: 'Logo 1' },
    { src: '/Images/hkutec-1024x183.png', alt: 'Logo 2' },
    { src: '/Images/logo4.png', alt: 'Logo 3' },
    { src: '/Images/HKSTP.png', alt: 'Logo 4' },
    { src: '/Images/Logo 5.png', alt: 'Logo 5' },
    { src: '/Images/Logo 6.png', alt: 'Logo 6' },
    { src: '/Images/Logo 7.png', alt: 'Logo 7' },
    { src: '/Images/Logo 6.png', alt: 'Logo 8' }
];

const LogoCarousel = () => {
    return (
        <div className="logo-carousel">
            <h2>Supported by</h2>
            <div className="logo-container">
                <div className="logo-wrapper">
                    {[...logos, ...logos].map((logo, index) => (
                        <div key={index} className="logo-slide">
                            <img src={logo.src} alt={logo.alt} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LogoCarousel;
